module.exports = __webpack_public_path__ + "static/media/tizianaterenzi.3163d3a3.png";